// Hook de cache para Today Services usando Tanstack Query
// Mantiene la misma interfaz que los servicios originales
import { useQuery } from '@tanstack/react-query'
import TodayServices from 'services/today'
import { axiosInstance } from 'services/axios-instance'
import * as end from 'constants/api'

/**
 * Hook de cache para datos de hoy - NO CAMBIA LA LÓGICA EXISTENTE
 * Solo añade una capa de cache inteligente
 */
export const useTodayQueries = userId => {
	// Cache para datos de today - USANDO SERVICIO ORIGINAL
	const todayQuery = useQuery({
		queryKey: ['today', userId],
		queryFn: () => TodayServices.getToday({ userId }),
		staleTime: 3 * 60 * 1000, // 3 minutos - datos del día pueden cambiar
		cacheTime: 10 * 60 * 1000, // 10 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Cache para quick access - USANDO SERVICIO ORIGINAL
	const quickAccessQuery = useQuery({
		queryKey: ['quick-access', userId],
		queryFn: () => axiosInstance.get(end.shortcuts({ userId })).then(res => res.data),
		staleTime: 5 * 60 * 1000, // 5 minutos
		cacheTime: 15 * 60 * 1000, // 15 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Función wrapper que mantiene la interfaz original
	const getCachedTodayData = () => {
		return new Promise((resolve, reject) => {
			if (todayQuery.data) {
				// useForToday espera res.status y res.data, así que mantenemos esa estructura
				resolve({ status: 200, data: todayQuery.data })
			} else if (todayQuery.error) {
				reject(todayQuery.error)
			} else {
				// Si no hay datos, refetch y esperar
				todayQuery.refetch().then(result => {
					if (result.data) {
						resolve({ status: 200, data: result.data })
					} else {
						reject(result.error || new Error('No data available'))
					}
				})
			}
		})
	}

	// Función wrapper para quick access
	const getCachedQuickAccess = () => {
		return new Promise((resolve, reject) => {
			if (quickAccessQuery.data) {
				// axiosInstance ya devuelve res.data, mantenemos la interfaz original
				resolve(quickAccessQuery.data)
			} else if (quickAccessQuery.error) {
				reject(quickAccessQuery.error)
			} else {
				quickAccessQuery.refetch().then(result => {
					if (result.data) {
						resolve(result.data)
					} else {
						reject(result.error || new Error('No data available'))
					}
				})
			}
		})
	}

	return {
		// Datos de las queries
		todayData: todayQuery.data,
		quickAccessData: quickAccessQuery.data,

		// Estados de loading
		todayLoading: todayQuery.isLoading,
		quickAccessLoading: quickAccessQuery.isLoading,

		// Errores
		todayError: todayQuery.error,
		quickAccessError: quickAccessQuery.error,

		// Funciones wrapper que mantienen la interfaz original
		getCachedTodayData,
		getCachedQuickAccess,

		// Funciones para invalidar cache cuando sea necesario
		invalidateTodayData: () => todayQuery.refetch(),
		invalidateQuickAccess: () => quickAccessQuery.refetch()
	}
}

export default useTodayQueries
